<template>
  <b-modal id="view_contact_login_modal" ref="view_contact_login_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="fas fa-user-tie"></i>
          <span>Contact Login</span>
        </h1>
      </div>
      <button id="mh-close" class="btn-close" v-on:click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row" v-if="notEmptyObject(contact)">
      <div class="col-12"><h3 class="bp_color font-weight-bold mb-0">{{ contact.user.first_name }} {{ contact.user.surname }}</h3></div>
      <div class="col-12"
           v-if="contact.rel_profile.job_title_id !== null && contact.rel_profile.job_title !== null"><h5 class="mb-3">{{ contact.rel_profile.job_title.job_title }}</h5></div>
      <div class="col-3"><strong>User Created:</strong></div>
      <div class="col-9">{{ contact.user.created_at | formatDateTime }}</div>
      <div class="col-3"><strong>Login Email:</strong></div>
      <div class="col-9">{{ contact.user.email }}</div>
      <div class="col-12">
        <hr>
      </div>

      <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))" class="col-12">
        <ValidationObserver ref="updatePasswordForm" slim>
          <form role="form" @submit.prevent="update_password_submit">
            <div class="row">
              <div class="col-12">
                <h4>Update User Password</h4>
              </div>

              <div class="col-6 form-group">
                <ValidationProvider rules="required|min:6|verify_password|password:@Confirmation" name="Password" v-slot="{ errors, classes }">
                  <label class="form-label" for="password">Password</label>
                  <input type="text" v-model="password" id="password" name="password" class="form-input" :class="classes" autocomplete="off"/>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <div class="col-6 form-group">
                <ValidationProvider rules="required|password:@Password" name="Confirmation" v-slot="{ errors, classes }">
                  <label class="form-label" for="confirmation">Confirmation</label>
                  <input type="text" v-model="confirmation" id="confirmation" name="confirmation" class="form-input" :class="classes" autocomplete="off"/>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>

              <div class="col-6 offset-6">
                <button type="submit" class="btn orcaBtn">Update Password</button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>

      <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))" class="col-12">
        <hr>
      </div>

      <div v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager'))" class="col-12">
        <form role="form" @submit.prevent="">
          <div class="row">
            <div class="col-12">
              <h4>Disable/Delete User</h4>
              <p>Use the buttons below to either disable a user's login or delete the login completely.</p>
            </div>

            <div class="col-6">
              <button @click.prevent="delete_contact_user" class="btn orcaBtn danger">Delete User</button>
            </div>
            <div class="col-6">
              <button @click.prevent="disable_contact_user" class="btn orcaBtn warning">Disable User</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "view_contact_login",
  data() {
    return {
      password: '',
      confirmation: '',

      contact: this.$store.state.timesheets.view_login_contact,
    }
  },
  methods: {
    hideModal() {
      this.$refs.view_contact_login_modal.hide();
      this.$store.commit('HIDE_CONTACT_LOGIN_MODALS');
    },
    update_password_submit() {
      this.$refs.updatePasswordForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updatePasswordForm);
        }
        else {
          let user_update = {
            id: this.contact.user.id,
            password: this.password,
            password_confirmation: this.confirmation
          };

          axios.patch(this.crmApiPath + 'user/contact/update_password/' + this.contact.user.id, user_update).then(() => {
            this.hideModal();
            this.$snotify.success(this.contact.person.first_name + ' ' + this.contact.person.surname + ' : Password Updated ');
            this.$bus.$emit('contacts::reload', {type: 'contact', action: true});
          })
        }
      });
    },
    delete_contact_user() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete User Login</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to delete this users login:<br><br>' + this.contact.person.first_name + ' ' + this.contact.person.surname +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'user/contact/delete/' + this.contact.user.id).then(() => {
                this.hideModal();
                this.$nextTick(() => {
                  this.$bus.$emit('default_company_ts_auth::reload', {action: true});
                  this.$bus.$emit('contacts::reload', {type: 'contact', action: true});
                })
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    disable_contact_user() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Disable User Login</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to disable this users login:<br><br>' + this.contact.person.first_name + ' ' + this.contact.person.surname +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);

              let disable_user = {
                id: this.contact.user.id,
                active: false
              };

              axios.patch(this.crmApiPath + 'user/contact/disable/' + this.contact.user.id, disable_user).then(() => {
                this.hideModal();
                this.$nextTick(() => {
                  this.$bus.$emit('default_company_ts_auth::reload', {action: true});
                  this.$bus.$emit('contacts::reload', {type: 'contact', action: true});
                })
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    }
  }
}
</script>

<style scoped lang="scss">
#view_contact_login_modal {
  #mh-info {
    span {
      display:     block;
      width:       100%;
      line-height: 0.9rem;
    }
  }
}
</style>
